export default __webpack_public_path__ + "static/media/miroslav.7c806490.jpg";